import { isNil } from 'lodash';
import { createSelector } from 'reselect';
import { getAddressLabel } from '../services/AddressService';

const movementsSelector = ({ liveDeparture }) => liveDeparture.movements;
const messagesSelector = ({ liveDeparture }) => liveDeparture.messages;
const filteredRoutesNamesSelector = ({ liveDeparture }) => liveDeparture.filteredRoutesNames;
const selectionSelector = ({ liveDeparture }) => liveDeparture.selection;

export const getSelectedStop = createSelector(
  [selectionSelector],
  (selection) => {
    if (selection?.category !== 'BUSSTOP' || !selection?.address) {
      return null;
    }

    const address = getAddressLabel(selection);
    const stopLabels = address.split(' - ');
    if (stopLabels.length >= 2) {
      return {
        stopCode: stopLabels[0],
        stopAddress: stopLabels[1],
      };
    }
    return null;
  },
);

export const hasNoDataSelector = createSelector([movementsSelector], movements => !movements);

export const getMovements = createSelector([movementsSelector], movements => movements ?? null);

export const hasMovementsSelector = createSelector([movementsSelector], movements => !!movements?.length);

export const filteredMovementsSelector = createSelector(
  [movementsSelector, filteredRoutesNamesSelector],
  (movements, filteredRoutesNames) => movements?.filter(({ route_short_name: routeShortName }) => !filteredRoutesNames?.length || filteredRoutesNames.includes(routeShortName)) ?? [],
);

export const hasFilteredMovementsSelector = createSelector([filteredMovementsSelector], filteredMovements => !!filteredMovements?.length);

export const isRequestingMoreMovements = ({ liveDeparture }) => liveDeparture.isRequestingMore;

export const hasNoMoreMovements = ({ liveDeparture }) => liveDeparture.noMoreMovements;

export const getStaticStopsInfo = ({ liveDeparture }) => liveDeparture.staticStopsInfo;

export const hasErrorSelector = ({ liveDeparture }) => !isNil(liveDeparture.errors);

// The backend actually returns only 1 message in the array
export const getMessage = createSelector(messagesSelector, messages => messages?.[0]);

export const getHasEmergencyMessage = createSelector(getMessage, message => message?.priority === 'emergency');

export const getHasCriticalMessage = createSelector(getMessage, message => message?.priority === 'critical');

export const displaySurveyButtonSelector = ({ liveDeparture }) => liveDeparture.displaySurveyButton;
